import React from "react";
import "./DropdownRead.scss";
export interface Props {
  label: string;
  value: string | number | null;
  required?: boolean;
}
const DropdownRead = ({ label, value, required = false }: Props) => {
  return (
    <div className="readOnlyDropo">
      <label>
        {label}
        {required ? <span>*</span> : ""}
      </label>
      <p>{value}</p>
    </div>
  );
};

export default DropdownRead;
